import { FC } from 'react';
import { useGettext } from '@cranium/i18n';
import { Title } from '@pages/Login/component';
import styled from 'styled-components';
//eslint-disable-next-line no-restricted-imports
import { Link, useParams } from 'react-router-dom';
import type { IdentityTypeEnum } from '@/gql/types.generated';

export const Success: FC = () => {
  const { gettext } = useGettext();
  const { identity } = useParams<{ identity: IdentityTypeEnum }>();
  return (
    <Main>
      <Title>{gettext('Password Reset Success')}</Title>
      <Description>{gettext('Your password has been successfully reset')}</Description>
      <Link to={`/login/${identity}`}>
        <i className="icon-arrow-left" />
        {gettext('Back to login page')}
      </Link>
    </Main>
  );
};

const Main = styled.div`
  width: 420px;
  max-width: 100%;

  > h1 {
    margin-bottom: 8px;
  }

  a {
    display: flex;
    align-items: center;
    gap: 4px;
    &:hover {
      color: var(--green-7);
      text-decoration: none;
    }
  }
`;

const Description = styled.p`
  font: var(--font-regular-14);
  color: var(--gray-7);
  display: flex;
  align-items: center;
  gap: 4px;
  b {
    color: var(--gray-10);
  }
`;
